// src/offline/salvaOffline.js
//
// Il percorso che segue un rapportino compilato senza rete, uguale per
// tutte le pagine: genera il PDF, lo scarica cosi' il tecnico ha qualcosa
// da mostrare e da stampare, e mette tutto in coda.
//
// Il PDF prodotto qui NON porta il codice interno: lo assegna il server
// quando riceve i dati. La copia definitiva, quella che finisce in archivio
// e in mail, viene rigenerata al momento dell'invio (vedi outbox.js).

import { accoda, TIPI } from './outbox';
import { generateManutenzionePdfBlob, generateVitPdfBlob } from '../pdf/clientPdf';

export { TIPI };

/** Vero se in questo momento non c'e' rete. */
export function senzaRete() {
  return typeof navigator !== 'undefined' && navigator.onLine === false;
}

function scarica(blob, nome) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nome;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export const MESSAGGIO_OFFLINE =
  'Nessuna rete: il rapportino e salvato sul dispositivo e verra inviato da solo ' +
  'appena torni online, gas compreso. Il codice interno viene assegnato in quel ' +
  'momento, quindi il PDF appena scaricato non lo riporta.';

/**
 * @param {Object} p
 * @param {string} p.tipo               TIPI.MANUTENZIONE o TIPI.VIT
 * @param {string} p.template
 * @param {Object} p.formData
 * @param {Object=} p.checks            solo manutenzione
 * @param {string=} p.tecnicoSignature
 * @param {string=} p.clienteSignature
 * @param {Object} p.datiIniziali       corpo per la rotta init
 * @param {Object=} p.summary           riepilogo per la rotta complete
 * @param {Object=} p.gas               gas usato e recuperato
 * @param {string=} p.nomeFile
 * @param {string=} p.codiceInterno     se la lavorazione esiste gia' e il codice
 *                                      e' noto: allora il PDF puo' portarlo
 * @param {string=} p.workOrderId       lavorazione gia' esistente
 * @param {Object=} p.rotte             rotte diverse da quelle standard
 */
export async function salvaOffline({
  tipo,
  template,
  formData,
  checks = {},
  tecnicoSignature = null,
  clienteSignature = null,
  datiIniziali,
  summary = {},
  gas = null,
  nomeFile,
  codiceInterno = '',
  workOrderId = null,
  rotte = null,
  extraCompletamento = null,
}) {
  // se il codice esiste gia' (rapportino assegnato) il PDF lo porta subito;
  // altrimenti resta vuoto e arriva alla sincronizzazione
  const senzaCodice = { ...formData, codiceInterno: codiceInterno || '' };

  const blob =
    tipo === TIPI.VIT
      ? await generateVitPdfBlob({
          template,
          formData: senzaCodice,
          tecnicoSignature,
          clienteSignature,
        })
      : await generateManutenzionePdfBlob({
          template,
          formData: senzaCodice,
          checks,
          tecnicoSignature,
          clienteSignature,
        });

  scarica(
    blob,
    nomeFile ||
      (tipo === TIPI.VIT
        ? 'verbale_intervento_da_sincronizzare.pdf'
        : 'verbale_manutenzione_da_sincronizzare.pdf')
  );

  await accoda({
    tipo,
    datiIniziali,
    datiCompletamento: {
      formData: senzaCodice,
      checks,
      tecnicoSignature,
      clienteSignature,
      template,
      summary: { ...summary, codiceInterno: codiceInterno || '' },
      ...(extraCompletamento || {}),
    },
    pdf: blob,
    gas,
    workOrderId,
    rotte,
  });

  return blob;
}
